/* eslint-disable consistent-return,array-callback-return,valid-typeof,react/jsx-props-no-spreading,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import {
  Card,
  Select,
  DatePicker,
  Form,
  Button,
  Divider,
  Tooltip,
  Checkbox,
  Row,
  Col,
  Modal,
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import { useHistory, useParams } from "react-router-dom";
import find from "lodash/find";
import omit from "lodash/omit";
import moment from "moment";
import {
  displayFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import useTaxRate from "../../lib/hooks/useTaxRate";
import {
  fetchBillStatus,
  fetchBillType,
  fetchPayStatus,
  fetchServiceStatus,
} from "../../store/slices/rtkDictionaries";
import { fetchBillsByAggId, postBill } from "../../store/slices/bills";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { setBillsFaximileWith } from "../../store/slices/settings";
import InputNumberFormat from "../common/InputNumberFormat";
import loadingStatusCodes from "../../lib/const/loadingStatusCodes";
import { toHttpFormat } from "../../lib/utils";
import { fetchDocumentTemplates } from "../../store/slices/documentTemplates";
import { fetchServiceAgreementVersions } from "../../store/slices/services";

const styles = {
  selectTemplate: {
    width: "150px",
  },
  selectFormat: {
    width: "150px",
  },
};

const { RangePicker } = DatePicker;
const { Option } = Select;
const dateFormat = displayFormat;

const AccountInvoicingAmount = ({ toggleServicesIncludePastDates, isServicesIncludePastDates }) => {
  const dispatch = useDispatch();
  const { productsList, productsListLoading } = useSelector((state) => state.products);
  const { agreements } = useSelector((state) => state.agreements);
  const { accountId } = useParams();
  const { account } = useSelector((state) => state.accounts);
  const { serviceStatus } = useSelector((state) => state.rtkDictionaries);
  const [serviceIdValue, setServiceIdValue] = useState();
  const [withEmails, setWithEmails] = useState(true);
  const [postRequest, setPostRequest] = useState({
    fromDate: "",
    periodFrom: "",
    periodTo: "",
    amount: undefined,
    serviceIds: undefined,
  });
  const [form] = Form.useForm();

  const [validationPeriodFrom, setValidationPeriodFrom] = useState();
  const history = useHistory();

  const [disabledFromDatesForCalendar, setDisabledFromDatesForCalendar] = useState("");
  const [disabledToDatesForCalendar, setDisabledToDatesForCalendar] = useState("");
  const { postBillLoading } = useSelector((state) => state.bills);
  const { billsFaximileWith } = useSelector((state) => state.settings);
  const { templates, templatesLoading } = useSelector((state) => state?.documentTemplates);

  const [taxRate] = useTaxRate({
    serviceTypeId:
      productsList &&
      productsList.length !== 0 &&
      productsList.find((item) => item.id === serviceIdValue)?.serviceType.id,
    date: postRequest.periodFrom,
  });

  // Загрузка шаблонов
  useEffect(() => {
    const params = { reportTypeId: 1 };
    params.onDate = postRequest?.fromDate
      ? toHttpFormat(postRequest?.fromDate)
      : toHttpFormat(moment());
    dispatch(fetchDocumentTemplates(params));
  }, [postRequest?.fromDate]);

  // const disabledToDate = (current) => {
  //   if (validationPeriodFrom) {
  //     return (
  //       current &&
  //       moment(current).isAfter(validationPeriodFrom, "day") &&
  //       moment(current).isAfter(moment(validationPeriodFrom).endOf("month"), "day")
  //     );
  //   }
  // };

  const getAddedBillData = () => {

    const getAllIds = (productsList) => {
      const ids = [];

      const collectIds = (node) => {
        if (node.id) {
          ids.push(node.id);
        }

        if (node.children && node.children.length > 0) {
          node.children.forEach(child => collectIds(child));
        }
      }

      collectIds(productsList);
      return ids;
    }

    const findProduct = productsList.find((product) => product.id === postRequest.serviceIds[0]);

    const serviceIds = getAllIds(findProduct);

    const data = {
      ...omit(postRequest, "serviceStatusId", "amount", "serviceIds"),
      amountWithTax: postRequest.amount,
      sendBill: withEmails,
      serviceIds,
    };
    if (postRequest.serviceStatusId === 4) {
      data.waited = true;
    }
    if (!withEmails) {
      delete data.reportId;
    }
    if (postRequest.formatType === "PDF") {
      delete postRequest.formatType;
    }
    return data;
  };

  const handleSubmit = async () => {
    // return console.log(getAddedBillData());
    await dispatch(postBill(getAddedBillData()));
    history.push(`/accounts/${accountId}/bills`);
    dispatch(fetchPayStatus());
    dispatch(fetchBillStatus());
    dispatch(fetchBillType());
    dispatch(fetchServiceStatus());

    if (agreements.length !== 0) {
      const aggArray = new Set();
      agreements.map((item) => {
        aggArray.add(item.id);
      });
      dispatch(fetchBillsByAggId({ aggId: [...aggArray] }));
    }
  };

  const onChangeServiceType = (value, { product }) => {
    form.setFieldsValue({ service: value });
    setServiceIdValue(value);
    setPostRequest({
      ...postRequest,
      agreementId: productsList.find((item) => item.id === value).agreementId,
      serviceIds: [value],
      serviceStatusId: product.serviceStatusId,
    });

    // Нужно ограничить дату по min(fromDate) - max(toDate) версий договора
    dispatch(fetchServiceAgreementVersions({ serviceAgreementIds: [product.agreementId] })).then(({ payload }) => {
      const arrAgreements = payload[0];

      if (arrAgreements && arrAgreements.length > 0) {
        setDisabledFromDatesForCalendar(
          arrAgreements[0].fromDate ? toHttpFormatStartOfDay(arrAgreements[0].fromDate) : ""
        );
        setDisabledToDatesForCalendar(
          arrAgreements[arrAgreements.length - 1].toDate ? toHttpFormatEndOfDay(arrAgreements[arrAgreements.length - 1].toDate) : ""
        );
      }
    });

    if (product.serviceStatusId === 4) {
      Modal.warning({
        title: "Внимание!",
        content: `Выбран продукт в статусе "Ожидает"`,
      });
    }
  };

  const resetServiceType = () => {
    form.resetFields(["service", "range", "fromDate"]);
    setServiceIdValue();
    setPostRequest({
      ...postRequest,
      agreementId: undefined,
      serviceIds: "",
    });

    setDisabledFromDatesForCalendar("");
    setDisabledToDatesForCalendar("");
  };

  const getDisabledDateBill = (cur) => {
    if (disabledFromDatesForCalendar && disabledToDatesForCalendar) {
      const fromDateMoment = moment(disabledFromDatesForCalendar);
      const toDateMoment = moment(disabledToDatesForCalendar);
      return moment(cur).isBefore(fromDateMoment) || moment(cur).isAfter(toDateMoment);
    }
    return false;
  };

  const handleChangeAmount = (value) => {
    setPostRequest({
      ...postRequest,
      amount: value,
    });
  };

  const isAgreementVisible = agreements?.length > 1;

  const getTooltipTitle = (item) => {
    const cellStyle = {
      border: `1px solid rgba(0, 0, 0, 0.1)`,
      padding: "5px",
      color: "rgba(0, 0, 0, 0.3)",
      backgroundColor: "white",
    };
    return (
      <div style={{ display: "flex" }}>
        {isAgreementVisible && <div style={cellStyle}>{item.agreement.agreementNumber}</div>}
        <div style={cellStyle}>{item.serviceType?.name}</div>
        <div style={cellStyle}>{item.offering?.extName}</div>
        <div style={cellStyle}>{find(serviceStatus, { id: item.serviceStatusId })?.name}</div>
        <div style={cellStyle}>{moment(item.fromDate).format(displayFormat)}</div>
        <div style={cellStyle}>{moment(item.toDate).format(displayFormat)}</div>
        <div style={cellStyle}>{item.id}</div>
      </div>
    );
  };

  const handleChangeBillsFaximileWith = () => {
    dispatch(setBillsFaximileWith(!billsFaximileWith));
  };

  const renderSelectTemplates = () => (
    <Select
      placeholder="Выберите шаблон"
      style={styles.selectTemplate}
      loading={templatesLoading === loadingStatusCodes.pending}
      onChange={(value) => {
        setPostRequest({
          ...postRequest,
          reportId: value,
        });
      }}
      allowClear
    >
      {Array.isArray(templates) &&
        templates.length !== 0 &&
        templates.map((item) => (
          <Option key={uuid()} value={item.id}>
            {item.defaultTemplate ? `${item.name} (по умолчанию)` : item.name}
          </Option>
        ))}
    </Select>
  );

  const renderSelectFormat = () => (
    <Select
      placeholder="Выберите формат"
      style={styles.selectTemplate}
      defaultValue="PDF"
      onChange={(value) => {
        setPostRequest({
          ...postRequest,
          formatType: value,
        });
      }}
    >
      {[{ value: "PDF" }, { value: "XLSX" }].map((item) => (
        <Option key={uuid()} value={item.value}>
          {item.value}
        </Option>
      ))}
    </Select>
  );

  const renderCheckbox = () => (
    <Checkbox checked={withEmails} onChange={() => setWithEmails(!withEmails)}>
      <label>Отправить счет по адресам</label>
    </Checkbox>
  );

  const handleCheckServicesIncludePastDates = (e) => {
    resetServiceType();
    toggleServicesIncludePastDates(e);
  };

  return (
    <Card title="Выставление счета на предоплату" bordered={false}>
      <Form onFinish={handleSubmit} form={form}>
        <Row>
          <Col span={11} style={{ display: "flex" }}>
            <div
              style={{
                whiteSpace: "pre",
                marginTop: "6px",
                marginRight: "15px",
              }}
            >
              По продукту:
            </div>
            <Form.Item
              name="service"
              rules={[{ required: true, message: "Пожалуйста, выберите продукт" }]}
              style={{ width: "100%" }}
            >
              <Select
                placeholder="Выберите продукт"
                loading={checkIsLoading(productsListLoading)}
                onChange={onChangeServiceType}
                style={{ width: "100%" }}
              >
                {productsList &&
                  productsList.length !== 0 &&
                  productsList
                    .filter(
                      ({ serviceProfile, serviceStatusId }) =>
                        serviceProfile.paymentTypeId === 1 && serviceStatusId !== 5
                    )
                    .map((item) => (
                      <Option key={uuid()} value={item.id} product={item}>
                        <Tooltip
                          overlayInnerStyle={{
                            display: "inline-block",
                            whiteSpace: "nowrap",
                            padding: "0",
                          }}
                          title={getTooltipTitle(item)}
                        >
                          <div>
                            {isAgreementVisible && (
                              <div>
                                {`${item.id} | ${item.agreement.agreementNumber} | ${item.serviceType?.name} | ${item.offering?.extName}`}
                              </div>
                            )}
                            {!isAgreementVisible && (
                              <div>{`${item.id} | ${item.serviceType?.name} | ${item.offering?.extName}`}</div>
                            )}
                          </div>
                        </Tooltip>
                      </Option>
                    ))}
              </Select>
            </Form.Item>
          </Col>
          <Col offset={1}>
            <Checkbox
              checked={isServicesIncludePastDates}
              onChange={handleCheckServicesIncludePastDates}
              style={{ marginTop: "5px" }}
            >
              Только закрытые
            </Checkbox>
          </Col>
        </Row>
        <Row>
          <Col span={11} style={{ display: "flex" }}>
            <div
              style={{
                whiteSpace: "pre",
                marginTop: "6px",
                marginRight: "15px",
                marginLeft: "18px",
              }}
            >
              Сумма:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            </div>
            <Form.Item
              name="amount"
              rules={[
                () => ({
                  validator(rule, value) {
                    if (!Number(value)) return Promise.reject(Error("Пожалуйста, введите сумму"));
                    return Promise.resolve();
                  },
                }),
              ]}
            >
              <InputNumberFormat
                placeholder="Введите сумму в валюте тарифа"
                allowNegative={false}
                onChange={handleChangeAmount}
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Col>
        </Row>
        <Divider />
        <Row gutter={48}>
          <Col>
            <Form.Item
              label="Период счета"
              name="range"
              rules={[{ required: true, message: "Пожалуйста, введите период счёта" }]}
            >
              <RangePicker
                style={{ width: "100%" }}
                // onCalendarChange={(dates) => {
                //   if (dates) {
                //     setValidationPeriodFrom(dates[0]);
                //   } else setValidationPeriodFrom();
                // }}
                // onOpenChange={() => {
                //   if (!postRequest.periodTo) {
                //     setValidationPeriodFrom();
                //   }
                // }}
                onChange={(value) => {
                  setPostRequest({
                    ...postRequest,
                    periodFrom: value ? toHttpFormatStartOfDay(value[0]) : "",
                    periodTo: value ? toHttpFormatEndOfDay(value[1]) : "",
                  });
                }}
                format={dateFormat}
              // disabledDate={disabledToDate}
              />
            </Form.Item>
            <Form.Item label="Дата счета" name="fromDate">
              <DatePicker
                onChange={(value) => {
                  setPostRequest({
                    ...postRequest,
                    fromDate: value ? toHttpFormatStartOfDay(value) : "",
                  });
                }}
                format={dateFormat}
                disabledDate={getDisabledDateBill}
              />
            </Form.Item>
          </Col>

          <Col>
            <Form.Item name="formatType" label="Формат документа">
              {renderSelectFormat()}
            </Form.Item>
            <Form.Item name="reportId" label="Шаблон">
              {renderSelectTemplates()}
            </Form.Item>
          </Col>

          <Col>
            <Card
              headStyle={{ padding: "0 20px" }}
              title={renderCheckbox()}
              bodyStyle={{
                width: "360px",
                height: "138px",
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                color: "#8c8c8c",
              }}
            >
              {account.billDeliveryEmails.map((e, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <span key={index} className="invoice__email">
                  {e.email}
                </span>
              ))}
            </Card>
          </Col>
        </Row>
        <Form.Item
          align="center"
          style={{
            textAlign: "center",
            marginTop: "30px",
          }}
        >
          {false && ( // пока решено скрыть
            <Checkbox
              style={{ display: "block", marginBottom: "15px" }}
              checked={billsFaximileWith}
              onChange={handleChangeBillsFaximileWith}
            >
              Счет с факсимиле
            </Checkbox>
          )}
          <Button key="back" htmlType="button" onClick={history.goBack}>
            Назад
          </Button>
          <Button
            style={{ marginLeft: "5px" }}
            key="submit"
            htmlType="submit"
            type="primary"
            loading={checkIsLoading(postBillLoading)}
          >
            Создать счет
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default AccountInvoicingAmount;
